import { CollectionReference, doc, DocumentReference, Firestore } from '@angular/fire/firestore';
import { JobPosting } from '../../models/job-posting/job-posting.model';
import { getCollectionRef, getRefFromPath } from '../utils/firestore.refs';
import { Organization } from '../../models/organization/organization.model';
import { JOB_POSTINGS_COLLECTION } from '../paths/job-posting.path';

export function getJobPostingsCol(parentRef: DocumentReference<Organization>): CollectionReference<JobPosting> {
  return getCollectionRef<JobPosting>(parentRef, JOB_POSTINGS_COLLECTION);
}

export function getJobPostingRef(
  parentRef: DocumentReference<Organization>,
  jobPostingId: string
): DocumentReference<JobPosting> {
  const col = getJobPostingsCol(parentRef);
  return doc(col, jobPostingId);
}

export function getJobPostingRefFromPath(firestore: Firestore, path: string): DocumentReference<JobPosting> {
  return getRefFromPath<JobPosting>(firestore, path);
}
